/**
 * 这个和后端的 AiTypeEnum 对应
 */
export enum AiModelEnum {
    DeepSeek = 'deep_seek',
    DeepSeekThinking = 'deep_seek_thinking',

    TongYiQianWen = 'tong_yi_qian_wen',
    HunYuan = 'hun_yuan',
    WenXinYiYan = 'wen_xin_yi_yan',
    DouBao = 'dou_bao'
}

export enum AiUtilTypeEnum {
    TextDefault = 'text_default',
    TextScenario = 'text_scenario',
    TextCreation = 'text_creation',
    GenerateImage = 'generate_image',
    GenerateVideo = 'generate_video'
}

export enum AiMessageRoleEnum {
    System = 'system',
    User = 'user'
}

export type HistoryTextScenarioDto = {
    utilType: AiUtilTypeEnum
    id: number
    avatar: string
    name: string
    content: string
}

export type Size = {
    x: number
    y: number
}

export type ImageStyle = {
    name: string
    value: string
}

export enum ResolutionRatioEnum {
    R_16_9 = '16:9',
    R_9_16 = '9:16',
    R_1_1 = '1:1',
    R_4_3 = '4:3',
    R_3_4 = '3:4'
}

export type Resolution = {
    ratio: ResolutionRatioEnum
    size: Size
}
